// Delivery
var Decoration = (function (Backbone) {

	// TBD: Why we're doing that? Why we're need standalone validation function?
	// Also it seems strange, I think it should be decomposed.
	function validate(value, validateType, minLinght, maxLength) {
		var isValid = true;
		var trimVal = (value || '').replace(/^\s*|\s*$/g, '');
		if (validateType == '*') {
			isValid = /.+/.test(trimVal);
		} else if (validateType == '@') {
			isValid = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(trimVal);
		} else if (validateType == ' ' && trimVal == '') {
			return true;
		}
		if (isValid) {
			var length = trimVal.length;
			if (minLinght != null) {
				isValid = isValid && length >= minLinght;
			}
			if (maxLength != null) {
				isValid = isValid && length <= maxLength;
			}
		}
		return isValid;
	}

	return Backbone.Model.extend({
		idAttribute: 'Name',
        
		defaults: {
            Label: null,
            Name: null,
            Type: null,
            DataType: null,
            Class: null,
            Value: null,
            MaxLength: null,
            MinLength: null,
            Validate: null,
            ReadOnly: null,
            WithoutComma: null,
            Options: null,
            Regexp: null,
            ValidateConsistency: null,
            Suggestion: null,
            hidden: null
        },

		setChangedByUser: function () {
			this._changedByUser = true;
			return this;
		},

		clearChangedByUser: function () {
			this._changedByUser = false;
			return this;
		},

		isChangedByUser: function () {
			return this._changedByUser;
		},

		clearValue: function () {
			this.set('Value', '');
			return this;
		},

		setValue: function (value) {
			this.set('Value', value);
			this.isValid();
			return this;
		},

		isValid: function () {
			var isValid = this.checkValid();
			this.setValid(isValid);
			return isValid;
		},

		setValid: function (isValid) {
			this.set('isValid', isValid);
		},

		checkValid: function () {
            if (this.getHidden() === true) {
                return true;
            }
			return validate(this.get('Value'), this.get('Validate'), this.get('MinLength'), this.get('MaxLength'));
		},

		pcaUpdateModel: function () {
			this.trigger('pcaUpdateModel');
		},

		setHidden: function(value) {
		    var settings = CheckoutSettings.getBasketSettings();
		    if (settings.PickupPointsWOBilling) {
		        this.set('hidden', value);
		    }
		},

		getHidden: function() {
		    var settings = CheckoutSettings.getBasketSettings();
		    if (settings.PickupPointsWOBilling) {
		        return this.get('hidden');
		    }
		    return false;
		},

		_changedByUser: false
	});
})(Backbone);